import fetch from '../../utils/fetch'

export function userGetAuthCoupon(params) {
    return fetch({
        url: '/api/redeem/QRCode',
        method: 'POST',
        data: params
    })
}



